import { forwardRef } from "react";
import { ModalContentProps, ModalRefProps } from "@inntechcorp/it-design";
import BackOfficeContext from "Context/BackOfficeContext";

/**
 * 
 * ### Modal Root Wrapper
 * 
 * Modal'lar portal üzerinde açıldıkları için Context verilerine ulaşamaz.
 * Bu sınıf iletilen context'ler ile modal'lar için yeni context'ler yaratır.
 * Böylece modal'lar site üzerindeki tüm context verilerine ulaşabilir olur.
 * 
 */
const ModalRootWrapper = forwardRef<ModalRefProps, ModalContentProps>(
  (props, ref) => {

  const { modal: ModalContent, ...restModalProps } = props.modalProps;
  const { context, ...restProps } = props;

  return (
    <div>
      <BackOfficeContext.Provider value={props.context}>
        <ModalContent modalProps={restModalProps} {...restProps} ref={ref} />
      </BackOfficeContext.Provider>
    </div>
  )

});

export default ModalRootWrapper;